import React from "react";
import Tooltip from "@mui/material/Tooltip";

//import { NavLink } from 'react-router-dom';
import { NavLink } from "react-router-dom";
import DashboardMenu from "../../Components/Maps/DashboardMenu";
import PmsMenu from "./PmsMenu";
import { checkPrivileges } from "../../Helpers";
import ExtraMenu from "./ExtraMenu";
import NavbarSearchMenu from "./NavbarSearchMenu";
import { Trans as Translate } from "react-i18next";

const EXTRA_MENU_BREAKPOINTS = [
  { min: 1600, max: 500000, col: 9 },
  { min: 1440, max: 1599, col: 7 },
  { min: 1280, max: 1439, col: 6 },
  { min: 1100, max: 1279, col: 5 },
  { min: 960, max: 1099, col: 4 },
  { min: 768, max: 959, col: 3 },
  { min: 0, max: 767, col: 100 },
];

export default class Navbar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: "/monitoring",
      windowWidth: typeof window !== "undefined" ? window.innerWidth : 1440,
    };
  }

  handleChange = (event, newValue) => {
    this.setState({ value: newValue });
    this.props.history.push(newValue);
    return false;
  };

  componentWillMount() {
    if (this.props.location.pathname !== this.state.value) {
      this.setState({ value: this.props.location.pathname });
    }
  }

  componentDidMount() {
    this.handleResize = () => {
      const nextWidth = window.innerWidth;
      if (nextWidth !== this.state.windowWidth) {
        this.setState({ windowWidth: nextWidth });
      }
    };
    window.addEventListener("resize", this.handleResize);
  }

  componentWillUnmount() {
    if (this.handleResize) {
      window.removeEventListener("resize", this.handleResize);
    }
  }

  collapseMenu = () => {
    if (document.body.offsetWidth < 959) {
      this.props.collapseMenu();
    }
  };

  getSearchableItems = (activeOnly) => {
    const searchable = [];

    activeOnly.forEach((item) => {
      if (item.isDropdown) {
        if (checkPrivileges("aiPms")) {
          searchable.push({
            key: "ai-pms",
            title: this.props.translate
              ? this.props.translate("aiPms")
              : "AI PMS",
            href: "/missed-opportunities",
            icon: item.icon,
          });
          searchable.push({
            key: "user-pms",
            title: this.props.translate
              ? this.props.translate("userPms")
              : "User PMS",
            href: "/user-pms",
            icon: item.icon,
          });
        }
        return;
      }

      if (!item.href) return;

      searchable.push({
        key: item.state || item.href,
        title: item.title,
        href: item.href,
        icon: item.icon,
      });
    });

    return searchable;
  };

  getVisibleColCount = () => {
    const width = this.state.windowWidth;
    const match =
      EXTRA_MENU_BREAKPOINTS.find((r) => r.min <= width && width <= r.max) ||
      EXTRA_MENU_BREAKPOINTS[0];
    return match.col;
  };

  render() {
    const analytic =
      (checkPrivileges("dashboard") && (
        <DashboardMenu history={this.props.history} />
      )) ||
      null;
    const colCount = this.getVisibleColCount();
    const restMenu = [];
    const activeOnly = Object.values(this.props.items).filter((r) => r.checked);
    const searchableItems = this.getSearchableItems(activeOnly);
    const compactNav = this.state.windowWidth < 1280;

    activeOnly.forEach((item, index) => {
      if (index >= colCount) {
        if (item.isDropdown) {
          if (checkPrivileges("aiPms")) {
            restMenu.push(
              <NavLink
                className="navbar-menu-item"
                key={`${index}-ai-pms`}
                style={{
                  display: "flex",
                  padding: 10,
                  alignItems: "center",
                  gap: 10,
                }}
                to="/missed-opportunities"
                onClick={this.collapseMenu}
              >
                <item.icon fill="currentColor" width={20} height={20} />
                <Translate i18nKey="aiPms" />
              </NavLink>,
            );
            restMenu.push(
              <NavLink
                className="navbar-menu-item"
                key={`${index}-user-pms`}
                style={{
                  display: "flex",
                  padding: 10,
                  alignItems: "center",
                  gap: 10,
                }}
                to="/user-pms"
                onClick={this.collapseMenu}
              >
                <item.icon fill="currentColor" width={20} height={20} />
                <Translate i18nKey="userPms" />
              </NavLink>,
            );
          }
        } else {
          const { icon: ItemIcon } = item;
          restMenu.push(
            <NavLink
              className={"navbar-menu-item"}
              key={index}
              style={{
                display: "flex",
                padding: 10,
                alignItems: "center",
                gap: 10,
              }}
              to={item.href}
              onClick={this.collapseMenu}
            >
              <ItemIcon fill="currentColor" width={20} height={20} />
              {item.title}
            </NavLink>,
          );
        }
      }
    });

    return (
      <div
        className={`navbar-menu${compactNav ? " navbar-menu--compact" : ""}`}
      >
        {activeOnly.map((item, index) => {
          if (index < colCount) {
            if (item.isDropdown) {
              return (
                <div key={index}>
                  <PmsMenu
                    history={this.props.history}
                    themecolors={this.props.themecolors}
                    collapseMenu={this.collapseMenu}
                  />
                </div>
              );
            }
            const { icon: ItemIcon } = item;
            const navlink = (
              <Tooltip
                key={index}
                title={item.title}
                placement={undefined}
                classes={{
                  popper: "menu-popper",
                  tooltip: "menu-popper-tooltip",
                }}
              >
                <NavLink
                  className="navbar-menu-item"
                  onClick={this.collapseMenu}
                  to={item.href}
                  style={{ position: "relative" }}
                >
                  <ItemIcon fill="currentColor" width={20} height={20} />
                  {item.count !== undefined ? (
                    <span className="counter">
                      {item.count > 99 ? "99+" : item.count}
                    </span>
                  ) : null}
                  {checkPrivileges("deliverynoteMoreThanOneVehicleView") && (
                    <>
                      {item.state === "deliveryNote" ? (
                        <Tooltip
                          title={`You have ${this.props.logInUser?.dueDeliveryNoteCount ?? 0} repeated services`}
                          placement="right"
                        >
                          <span
                            style={{
                              position: "absolute",
                              top: -5,
                              right: -5,
                              backgroundColor: "white",
                              color: this.props.themecolors.themeLightColor,
                              border: `1px solid white`,
                              fontSize: "10px",
                              fontWeight: "bold",
                              borderRadius: "50%",
                              width: "18px",
                              height: "18px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            {(this.props.logInUser?.dueDeliveryNoteCount ?? 0) >
                            99
                              ? "99+"
                              : (this.props.logInUser?.dueDeliveryNoteCount ??
                                0)}
                          </span>
                        </Tooltip>
                      ) : null}
                      {item.state === "maintenance" ? (
                        <Tooltip
                          title={`You have ${parseInt(localStorage.getItem("waitingCustomerCount") || "0", 10)} waiting for customer approval services`}
                          placement="right"
                        >
                          <span
                            style={{
                              position: "absolute",
                              top: -5,
                              right: -5,
                              backgroundColor: "white",
                              color: this.props.themecolors.themeLightColor,
                              border: `1px solid white`,
                              fontSize: "10px",
                              fontWeight: "bold",
                              borderRadius: "50%",
                              width: "18px",
                              height: "18px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            {parseInt(
                              localStorage.getItem("waitingCustomerCount") ||
                                "0",
                              10,
                            ) > 99
                              ? "99+"
                              : parseInt(
                                  localStorage.getItem(
                                    "waitingCustomerCount",
                                  ) || "0",
                                  10,
                                )}
                          </span>
                        </Tooltip>
                      ) : null}
                    </>
                  )}
                  <span className="nav-link-text">{item.title}</span>
                </NavLink>
              </Tooltip>
            );

            return (
              <React.Fragment key={item.state || index}>
                {item.name === "dashboard" ? (
                  <>
                    <div key={item.name}>{navlink}</div>
                    {analytic}
                  </>
                ) : (
                  <div key={index}>{navlink}</div>
                )}
              </React.Fragment>
            );
          }
          return null;
        })}
        {restMenu.length ? <ExtraMenu>{restMenu}</ExtraMenu> : null}
        {searchableItems.length ? (
          <NavbarSearchMenu
            items={searchableItems}
            collapseMenu={this.collapseMenu}
          />
        ) : null}
      </div>
    );
  }
}
